import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoadingState from './ui/LoadingState';

const ManagerProtectedRoute = ({ children }) => {
  const { user, isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-background">
        <LoadingState />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const role = typeof user?.role === 'string' ? user.role.toLowerCase() : '';
  const isManager = role === 'manager' || role === 'admin';

  if (!isManager) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ManagerProtectedRoute;
